import api from '@/services/api'

export default {
    namespaced: true,
    state: {
        Initiatives: [],
        selected: ['todo', 'doing'],
    },
    mutations: {
        SET_Initiatives(state, Initiatives) {
            state.Initiatives = Initiatives
        },
        SET_selected(state, selected) {
            state.selected = selected
        },
    },
    actions: {
        async getInitiativesFromAPI({ commit, rootGetters }) {
            let periods = await rootGetters.periods
            const userID = await rootGetters['profile/currentProfileUserID']

            return api
                .get('initiatives', {
                    params: {
                        periods: periods,
                        search: `user_id:${userID}`,
                        with: 'keyResult',
                        searchFields: 'user_id:=',
                    },
                })
                .then((resp) => {
                    commit('SET_Initiatives', resp.data.data)
                })
        },
    },
    getters: {
        getInitiatives: (state) => {
            if (state.selected.length > 0) {
                return state.Initiatives.filter((initiative) => {
                    return state.selected.includes(initiative.status)
                })
            }
            return state.Initiatives
        },
        todoTotal: (state, getters) => {
            const todoTotal = getters.getInitiatives.filter((initiative) => {
                return initiative.status === 'todo'
            }).length

            return state.selected.includes('todo') ? todoTotal : null
        },
        doingTotal: (state, getters) => {
            const doingTotal = getters.getInitiatives.filter((initiative) => {
                return initiative.status === 'doing'
            }).length

            return state.selected.includes('doing') ? doingTotal : null
        },
        doneTotal: (state, getters) => {
            const doneTotal = getters.getInitiatives.filter((initiative) => {
                return initiative.status === 'done'
            }).length

            return state.selected.includes('done') ? doneTotal : null
        },
    },
}
